import { ActionTree, MutationTree } from 'vuex'
import { IRootState } from '@/store'
import { InvoicesOlsaActionType } from '@/store/modules/invoicesOlsa/interfaces/action-type'
import { InvoicesOlsaMutationType } from '@/store/modules/invoicesOlsa/interfaces/mutation-type'
import { IInvoicesOlsaState } from '@/store/modules/invoicesOlsa/interfaces/IInvoicesOlsaState'
import { IInvoicesOlsaMutations } from '@/store/modules/invoicesOlsa/interfaces/IInvoicesOlsaMutations'
import { IInvoiceOlsa } from '@/store/modules/invoicesOlsa/interfaces/invoicesOlsa/IInvoicesOlsaResponse'
import { invoicesOlsaAPI } from '@/store/modules/invoicesOlsa/api/invoicesOlsa-api'
import { IInvoicesOlsaRequest } from '@/store/modules/invoicesOlsa/interfaces/invoicesOlsa/IInvoicesOlsaRequest'
import { IInvoicesOlsaActions } from '@/store/modules/invoicesOlsa/interfaces/IInvoicesOlsaActions'
import { ISelectedInvoiceOlsaResponse } from '@/store/modules/invoicesOlsa/interfaces/selectedInvoiceOlsa/ISelectedInvoiceOlsaResponse'
import { ISelectedInvoiceOlsaRequest } from '@/store/modules/invoicesOlsa/interfaces/selectedInvoiceOlsa/ISelectedInvoiceOlsaRequest'
import { IDropdownItems } from '../common/interface/IDropdownItems'

const state = (): IInvoicesOlsaState => ({
  invoicesOlsa: [],
  documentTypes: [],
  total: 0,
  selectedInvoiceOlsa: null,
  loading: false,
  errors: null
})

const mutations: MutationTree<IInvoicesOlsaState> & IInvoicesOlsaMutations = {
  [InvoicesOlsaMutationType.SET_LOADING] (state: IInvoicesOlsaState, payload: boolean) {
    state.loading = payload
  },
  [InvoicesOlsaMutationType.SET_INVOICES_OLSA] (state: IInvoicesOlsaState, payload: IInvoiceOlsa[]) {
    state.invoicesOlsa = payload
  },
  [InvoicesOlsaMutationType.SET_INVOICES_OLSA_TOTAL] (state: IInvoicesOlsaState, payload: number) {
    state.total = payload
  },
  [InvoicesOlsaMutationType.SET_SELECTED_INVOICE_OLSA] (state: IInvoicesOlsaState, payload: ISelectedInvoiceOlsaResponse) {
    state.selectedInvoiceOlsa = payload
  },
  [InvoicesOlsaMutationType.SET_ERROR] (state: IInvoicesOlsaState, payload: any) {
    state.errors = payload
  },
  [InvoicesOlsaMutationType.SET_DOCUMENT_TYPE] (state: IInvoicesOlsaState, payload: any) {
    state.documentTypes = payload
  }
}

const actions: ActionTree<IInvoicesOlsaState, IRootState> & IInvoicesOlsaActions = {
  async [InvoicesOlsaActionType.FETCH_INVOICES_OLSA] ({ commit }, dto: IInvoicesOlsaRequest) {
    commit(InvoicesOlsaMutationType.SET_LOADING, true)
    try {
      const response = await invoicesOlsaAPI.getInvoicesOlsa(dto)
      commit(InvoicesOlsaMutationType.SET_INVOICES_OLSA, response.invoiceList)
      commit(InvoicesOlsaMutationType.SET_INVOICES_OLSA_TOTAL, response.total)
    } catch (error) {
      commit(InvoicesOlsaMutationType.SET_ERROR, error)
      commit(InvoicesOlsaMutationType.SET_LOADING, false)
    }
  },
  async [InvoicesOlsaActionType.FETCH_SELECTED_INVOICE_OLSA] ({ commit }, dto: ISelectedInvoiceOlsaRequest) {
    commit(InvoicesOlsaMutationType.SET_LOADING, true)
    try {
      const response = await invoicesOlsaAPI.getSelectedInvoiceOlsa(dto)
      commit(InvoicesOlsaMutationType.SET_SELECTED_INVOICE_OLSA, response)
    } catch (error) {
      commit(InvoicesOlsaMutationType.SET_ERROR, error)
      commit(InvoicesOlsaMutationType.SET_LOADING, false)
    }
  },
  async [InvoicesOlsaActionType.FETCH_DOCUMENT_TYPES] ({ commit }) {
    commit(InvoicesOlsaMutationType.SET_LOADING, true)
    try {
      const response = await invoicesOlsaAPI.getDocumentTypes() // Await for async operation

      let results: IDropdownItems[] = []
      if (Array.isArray(response) && response.length > 0) {
        results = response.map((d) => ({
          label: d.description,
          value: d.id
        }))
      }

      commit(InvoicesOlsaMutationType.SET_DOCUMENT_TYPE, results)
    } catch (error) {
      commit(InvoicesOlsaMutationType.SET_ERROR, error)
    }
    commit(InvoicesOlsaMutationType.SET_LOADING, false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
